export class ReportDatum {
    public x: string;
    public y: number;
    public grouping?: string;
    public metadata?: { name: string; value: any }[];
}

export class SignalReportDatum extends ReportDatum {
    public y_percent?: number;
    public y_totalcount?: number;
    public y_percenttotal?: number;
    public grouping_identifier?: string;
    public x_identifier?: string;
    public isSyntheticTemporalGap?: boolean;
}

export type SignalTableDatum = Record<string, unknown>;
